var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShow)?_c('div',{staticClass:"history_wrapper"},[_c('h2',{staticClass:"access_hidden"},[_vm._v("포인트 내역")]),(this.$route.name === 'PointHistory')?_c('div',[_c('point-info',{attrs:{"a2s":"pointHistory"}}),_c('point-list')],1):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }